<template>
    <a-form-model :model="form" ref="templateForm" :rules="rules">
      <a-form-model-item label="Link" prop="link">
        <a-input placeholder="https://www.olimp.bet/line/1/5956496/7848761" :disabled="loading" size="large" v-model="form.link"></a-input>
      </a-form-model-item>
      <a-form-model-item label="Link name" prop="linkName">
        <a-input placeholder="Enter link name" :disabled="loading" size="large" v-model="form.linkName"></a-input>
      </a-form-model-item>
      <hr>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button @click="closeModal">
            Cancel
          </a-button>
          <a-button type="primary" :disabled="isSaveDisabled" style="margin-left: 10px;" @click="onSubmit" :loading="loading">
            Save
          </a-button>
        </a-col>
      </a-row>
    </a-form-model>
  </template>
<script>
import apiClient from '@/services/axios'

export default {
  name: 'LinkTemplates',
  props: {
    templateLink: {
      type: String,
    },
  },
  components: {
  },
  data() {
    return {
      form: {
        link: '',
        linkName: '',
      },
      loading: false,
      langOptions: [],
      rules: {
        link: [{ required: true, message: 'Please input template link', trigger: 'blur' }],
        linkName: [{ required: true, message: 'Please input template name', trigger: 'blur' }],
      },
    }
  },
  computed: {
    isSaveDisabled() {
      return Object.values(this.form).some(value => value === '')
    },
  },
  async created() {
    if (this.templateLink) {
      this.form.link = this.templateLink
    }
  },
  methods: {
    async onSubmit() {
      const isValid = await new Promise((resolve) => {
        this.$refs.templateForm.validate(resolve)
      })
      if (!isValid) {
        return false
      }
      return await this.createLink()
    },
    async createLink() {
      try {
        this.loading = true

        const payload = {
          name: this.form.linkName,
          link: this.form.link,
        }

        const url = '/admin/links'

        const linkResponse = await apiClient.post(url, payload)
        if (linkResponse.data.error) {
          this.$notification.error({
            message: linkResponse.data.error.message,
          })
          this.loading = false
          return
        }
        this.$notification.success({
          message: 'Link has been successfully created',
        })
        this.emitCreatedLink(linkResponse.data.data)
      } catch (err) {
        const errorMessage =
          err.response?.data?.error?.message || err.message || 'An unexpected error occurred'

        this.$notification.error({
          message: errorMessage,
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    closeModal () {
      this.$emit('closeTemplateModal')
    },
    emitCreatedLink(newLink) {
      this.$emit('addLink', newLink)
    },
  },
}
</script>
  <style scoped>

  </style>
